export const FORM_STATIC_FIELD_OPTIONS = [
	{ label: "None", value: "none" as const },
	{ label: "First name", value: "first_name" as const },
	{ label: "Insertion", value: "insertion" as const },
	{ label: "Last name", value: "last_name" as const },
	{ label: "Phone", value: "phone" as const },
	{ label: "Phone work", value: "phone_work" as const },
	{ label: "Email", value: "email" as const },
	{ label: "Message", value: "message" as const },
	{ label: "Birth date", value: "birth_date" as const },
	{ label: "Birth place", value: "birth_place" as const },
	{ label: "Company", value: "company" as const },
	{ label: "Salutation", value: "salutation" as const },
	{ label: "Initials", value: "initials" as const },
	{ label: "Gender", value: "gender" as const },
	{ label: "Privacy Policy", value: "privacy_policy" as const },
	{ label: "Candidate available from", value: "candidate_available_from" as const },
] as const;

export type FormStaticFieldIdSelect = (typeof FORM_STATIC_FIELD_OPTIONS)[number]["value"];

export type FormStaticFieldId = Exclude<FormStaticFieldIdSelect, "none">;

export type FormStaticFieldValueMap = Partial<Record<FormStaticFieldId, string>>;

export function isFormStaticFieldId(value: unknown): value is FormStaticFieldId {
	if (typeof value !== "string") {
		return false;
	}

	return FORM_STATIC_FIELD_OPTIONS.some((o) => o.value !== "none" && o.value === value);
}

export function isFormStaticFieldIdSelect(value: unknown): value is FormStaticFieldIdSelect {
	if (typeof value !== "string") {
		return false;
	}

	return FORM_STATIC_FIELD_OPTIONS.some((o) => o.value === value);
}

export function resolveFormFieldPublicId(field: { id?: string | null; settings?: unknown; blockType?: string | null }): string {
	if (field.blockType === "form-search-profile") {
		return "search_profile";
	}

	const sid = (field.settings as { staticFieldId?: string | null } | undefined)?.staticFieldId;
	if (sid && sid !== "none") {
		return sid;
	}
	const rowId = field.id ?? "";
	return rowId.replace(/^static[-_]/i, "") || rowId;
}
